import { useContext } from 'react';
import { Outlet } from 'react-router-dom';

import { Logo } from 'common/components';
import { AdminLayout, AdminLayoutContext, SidebarState } from 'common/components/AdminLayout';

import { DASHBOARD_ROUTES } from '../../../dashboard/routes';

const ReceiptLayout = () => (
    <AdminLayout
        className="dashboard-layout"
        smallLogo={<Logo to={DASHBOARD_ROUTES.home.to} size="small" style={{ paddingLeft: 12 }} />}
        logo={<ReceiptLogo />}
    // headerContent={<Header email={email} logout={logout} />}
    // sidebarContent={<Sidebar />}
    >
        <Outlet />
    </AdminLayout>
);

export default ReceiptLayout;

const ReceiptLogo = () => {
    const { sidebarState } = useContext(AdminLayoutContext);

    return (
        <Logo
            to={DASHBOARD_ROUTES.home.to}
            size={sidebarState === SidebarState.COLLAPSED_SIDEBAR ? 'small' : 'large'}
            inverted
        />
    );
};
